<template>
  <div class="taglist-container" :class="{ 'dashboard-mode': dashboardMode }">
    <!-- 기존 TagList 표시 -->
    <div>
      <!-- 상단 요약 + 필터 버튼 섹션 (상단) -->
      <div class="filter-section" v-if="$tenant.layout === 'sdaa'">
        <div class="filter-wrapper">
          <!-- 좌측: 대시보드 요약 -->
          <div class="dashboard-summary">
            <div class="summary-item">
              <div class="summary-label">전체 등록</div>
              <div class="summary-value">{{ dashboard.totalAssets }}</div>
            </div>
            <div class="summary-item warning">
              <div class="summary-label">배터리 교체</div>
              <div class="summary-value">{{ dashboard.lowBatteryAssets }}</div>
            </div>
            <div class="summary-item inactive">
              <div class="summary-label">미인식</div>
              <div class="summary-value">{{ dashboard.inactiveAssets }}</div>
            </div>
          </div>

          <!-- 우측: 필터 버튼 -->
          <div class="filter-buttons">
          <!-- 첫 번째 줄: 733버튼 -->
          <div class="filter-row">
            <!-- 병동 버튼: 테넌트 프리셋 wards (없으면 All 만) -->
            <button
              v-for="w in $tenant.wards"
              :key="w.code"
              @click="toggleCodeGroup(w.prefix)"
              class="filter-btn"
              :class="{ active: selectedFilters.codeGroup === w.prefix }"
              :title="w.label"
            >
              {{ w.code }}
            </button>
            <button @click="clearCodeGroup" class="filter-btn clear-btn" :class="{ active: !selectedFilters.codeGroup }">All</button>
          </div>
          <!-- 두 번째 줄: 나머지 버튼들 -->
          <div class="filter-row">
            <button 
              @click="toggleDeviceGroup('VarioS')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'VarioS' }"
            >
             VarioS
            </button>
            <button 
              @click="toggleDeviceGroup('DVT')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'DVT' }"
            >
              DVT
            </button>
            <button 
              @click="toggleDeviceGroup('Nebulizer')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'Nebulizer' }"
            >
              Nebulizer
            </button>
            <button 
              @click="toggleDeviceGroup('SCD')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'SCD' }"
            >
              SCD
            </button>
            <button 
              @click="toggleDeviceGroup('Pulse_Oxi')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'Pulse_Oxi' }"
            >
              Pulse_Oxi
            </button>
            <button 
              @click="toggleDeviceGroup('H_Pulse_Oxi')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'H_Pulse_Oxi' }"
            >
              H_Pulse_Oxi
            </button>
            <button 
              @click="toggleDeviceGroup('Infusion')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'Infusion' }"
            >
              Infusion
            </button>
            <button 
              @click="toggleDeviceGroup('Feeding')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'Feeding' }"
            >
              Feeding
            </button>
            <button 
              @click="toggleDeviceGroup('Patient_M')" 
              class="filter-btn"
              :class="{ active: selectedFilters.deviceGroup === 'Patient_M' }"
            >
              Patient_M
            </button>
            <button @click="clearDeviceGroup" class="filter-btn clear-btn" :class="{ active: !selectedFilters.deviceGroup }">All</button>
          </div>
        </div>
        </div>
      </div>

      <!-- 메인 콘텐츠 카드 -->
      <div class="content-card">
        <div class="card-header">
          <h2>Tag List </h2>
          <div class="header-controls">
            <!-- 헤더 우측: 검색 + per page -->
            <div class="header-search">
              <input 
                type="text" 
                v-model="selectedFilters.searchText" 
                class="search-input"
                placeholder="Search all fields (minimum 2 characters)"
                @input="handleSearchInput"
              >
              <div class="items-per-page-selector">
                <label for="itemsPerPage">Items per page:</label>
                <select 
                  id="itemsPerPage" 
                  v-model="itemsPerPage" 
                  @change="changeItemsPerPage"
                  class="items-select"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="50">50</option>
                  <option :value="100">100</option>
                </select>
              </div>
            </div>
            <div class="view-toggle" v-if="isMobile">
              <button 
                @click="toggleView" 
                class="view-toggle-btn"
                :class="{ active: showCardView }"
              >
                {{ showCardView ? 'Table View' : 'Card View' }}
              </button>
            </div>
            <div class="exported-toggle">
              <button 
                @click="toggleExportedEquipment" 
                class="exported-toggle-btn"
                :class="{ active: showExportedEquipment }"
              >
                {{ showExportedEquipment ? '반출된 장비 숨기기' : '반출된 장비 보기' }}
              </button>
            </div>
            <div class="results-info" v-if="totalItems > 0">
              Showing {{ ((currentPage - 1) * itemsPerPage) + 1 }}-{{ Math.min(currentPage * itemsPerPage, totalItems) }} of {{ totalItems }} results
            </div>
          </div>
        </div>
        
        <!-- 카드뷰 (모바일 세로모드용) -->
        <div v-if="showCardView && isMobile" class="card-view-container">
          <div v-for="tag in tags" :key="tag.tag_mac" class="tag-card" :class="{ 'exported-card': tag.export_status === 'active' }">
            <div class="tag-card-header">
              <div class="tag-mac">{{ tag.tag_mac }}</div>
              <div class="device-name">{{ tag.devicename || 'N/A' }}</div>
            </div>
            
            <div class="tag-card-body">
              <div class="tag-info-row">
                <div class="info-item">
                  <span class="info-label">인식 시간:</span>
                  <span class="info-value">{{ formatSensingTime(tag.tag_sensingtime) }}</span>
                </div>
              </div>
              
              <div class="tag-info-row">
                <div class="info-item">
                  <span class="info-label">RSSI:</span>
                  <span class="info-value">
                    <span v-if="Math.abs(tag.tag_rssi) <= 70">
                      <span class="material-symbols-outlined rssi-good" style="font-size: 16px;">signal_cellular_alt</span>
                      <span>({{ tag.tag_rssi }})</span>
                    </span>
                    <span v-else>
                      <span class="material-symbols-outlined rssi-mid" style="font-size: 16px;">signal_cellular_alt_2_bar</span>
                      <span>({{ tag.tag_rssi }})</span>
                    </span>
                  </span>
                </div>
                
                <div class="info-item">
                  <span class="info-label">Temperature:</span>
                  <span class="info-value">
                    <span class="material-symbols-outlined thermostat" style="font-size: 14px;">device_thermostat</span>
                    <span>{{ tag.tag_temperature }} °C</span>
                  </span>
                </div>
              </div>
              
              <div class="tag-info-row">
                <div class="info-item">
                  <span class="info-label">Battery:</span>
                  <span class="info-value">
                    <span :class="getBatteryStatus(tag.tag_vol)">
                      {{ tag.tag_vol >= 2.7 ? 'Good' : tag.tag_vol >= 2.3 ? 'Mid' : 'None' }}
                    </span>
                    <span> ({{ tag.tag_vol.toFixed(1) }}v)</span>
                  </span>
                </div>
                
                <div class="info-item">
                  <span class="info-label">Active:</span>
                  <span class="info-value" :class="{ 'active-yes': tag.active === 0, 'active-no': tag.active !== 0 }">
                    {{ tag.active === 0 ? 'Yes' : 'No' }}
                  </span>
                </div>
              </div>
              
              <div class="tag-info-row">
                <div class="info-item full-width">
                  <span class="info-label">Gateway MAC:</span>
                  <span class="info-value">{{ tag.gw_mac_parent }}</span>
                </div>
              </div>
              
              <div class="tag-info-row">
                <div class="info-item full-width">
                  <span class="info-label">Location:</span>
                  <span class="info-value">{{ tag.taglocation || 'N/A' }}</span>
                </div>
              </div>
            </div>
            
            <div v-if="!dashboardMode" class="tag-card-footer">
              <button 
                v-if="isAdmin" 
                @click="openEditSidebar(tag)" 
                class="edit-btn card-edit-btn"
              >
                EDIT
              </button>
              <button 
                v-else 
                @click="tag.export_status === 'active' ? cancelExport(tag) : openExportModal(tag)" 
                class="export-btn card-export-btn"
                :class="{ 'export-cancelled-btn': tag.export_status === 'active' }"
              >
                {{ tag.export_status === 'active' ? '반출 취소' : '반출' }}
              </button>
            </div>
          </div>
        </div>
        
        <!-- 테이블 컨테이너 -->
        <div v-else class="table-container">
          <table class="tags-table">
            <thead>
              <tr>
                <th @click="sortTags('devicename')">장비명 <span :class="getArrowClass('devicename')"></span></th>
                <th @click="sortTags('taglocation')">위치<span :class="getArrowClass('taglocation')"></span></th>
                <th @click="sortTags('active')"> 활성여부 <span :class="getArrowClass('active')"></span></th>
                <th @click="sortTags('tag_sensingtime')">인식 시간 <span :class="getArrowClass('tag_sensingtime')"></span></th>
                <th @click="sortTags('tag_rssi')">신호 강도 <span :class="getArrowClass('tag_rssi')"></span></th>
                <th @click="sortTags('tag_temperature')">온도 <span :class="getArrowClass('tag_temperature')"></span></th>
                <th @click="sortTags('tag_vol')">배터리 <span :class="getArrowClass('tag_vol')"></span></th>
                <th v-if="!dashboardMode">수정</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="tag in tags" :key="tag.tag_mac" :class="{ 'stale-row': isStale(tag), 'exported-row': tag.export_status === 'active' }">
                <td>{{ tag.devicename }}</td>
                <td>{{ tag.taglocation }}</td>
                <td>{{ tag.active === 0 ? 'Yes' : 'No' }}</td>
                <td>{{ formatSensingTime(tag.tag_sensingtime) }}</td>
                <td>
                  <span v-if="Math.abs(tag.tag_rssi) <= 70">
                    <span class="material-symbols-outlined rssi-good" style="font-size: 24px;">signal_cellular_alt</span>
                    <span>({{ tag.tag_rssi }})</span>
                  </span>
                  <span v-else>
                    <span class="material-symbols-outlined rssi-mid" style="font-size: 24px;">signal_cellular_alt_2_bar</span>
                    <span>({{ tag.tag_rssi }})</span>
                  </span>
                </td>
                <td>
                  <span class="material-symbols-outlined thermostat" style="font-size: 16px;">device_thermostat</span>
                  <span> {{ tag.tag_temperature }} °C </span>
                </td>
                <td>
                  <span :class="getBatteryStatus(tag.tag_vol)">
                    {{ tag.tag_vol >= 2.7 ? 'Good' : tag.tag_vol >= 2.3 ? 'Mid' : 'None' }}
                  </span>
                  <span> ({{ tag.tag_vol.toFixed(1) }}v)</span>
                </td>
                <td v-if="!dashboardMode">
                  <button 
                    v-if="isAdmin" 
                    @click="openEditSidebar(tag)" 
                    class="edit-btn"
                  >
                    EDIT
                  </button>
                  <button 
                    v-else 
                    @click="tag.export_status === 'active' ? cancelExport(tag) : openExportModal(tag)" 
                    class="export-btn"
                    :class="{ 'export-cancelled-btn': tag.export_status === 'active' }"
                  >
                    {{ tag.export_status === 'active' ? '반출 취소' : '반출' }}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <!-- 페이지네이션 -->
        <div class="pagination">
          <button @click="prevPage" :disabled="currentPage === 1" class="pagination-btn">Previous</button>
          <span class="page-numbers">
            <span v-for="page in visiblePages" :key="page" @click="goToPage(page)" :class="{ active: currentPage === page }" class="page-number">{{ page }}</span>
          </span>
          <button @click="nextPage" :disabled="currentPage === totalPages" class="pagination-btn">Next</button>
        </div>
      </div>

      <!-- Edit Tag Sidebar -->
      <EditTag
        v-if="selectedTag" 
        :visible="isEditSidebarVisible"
        :tag="selectedTag"
        @save="updateTag"
        @close="closeEditSidebar"
      />

      <!-- Equipment Export Modal -->
      <EquipmentExportModal
        :visible="isExportModalVisible"
        :tag="selectedTagForExport"
        @close="closeExportModal"
        @exported="handleEquipmentExported"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EditTag from './EditTag.vue';
import EquipmentExportModal from './EquipmentExportModal.vue';

export default {
  name: 'TagList_old',
  components: {
    EditTag,
    EquipmentExportModal,
  },
  props: {
    dashboardMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      tags: [],
      sortKey: 'devicename',
      sortOrder: 1,
      updateInterval: 10,
      updateTimer: null,
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: 0,
      company: localStorage.getItem('company') || '',
      selectedFilters: {
        searchText: '',
        battery: '',
        rssi: '',
        active: '',
        location: '',
        startDate: '',
        endDate: '',
        codeGroup: '', // 73,74,83 중 하나
        deviceGroup: '' // 나머지 중 하나
      },
      filters: {
        searchText: '',
        battery: '',
        rssi: '',
        active: '',
        location: '',
        startDate: '',
        endDate: ''
      },
      filterQuery: '', // 추가: 쿼리 파라미터용
      searchInfo: '',
      searchTimeout: null,
      isEditSidebarVisible: false,
      selectedTag: null,
      showCardView: false,
      isMobile: false,
      dashboard: {
        totalAssets: 0,
        lowBatteryAssets: 0,
        inactiveAssets: 0
      },
      isAdmin: false,
      isExportModalVisible: false,
      selectedTagForExport: null,
      showExportedEquipment: false,
    };
  },
  created() {
    // company 정보 설정
    this.company = localStorage.getItem('company') || '';
    
    // 사용자 권한 확인
    this.checkUserPermission();
    
    // 대시보드 모드에서는 적은 데이터로 시작
    if (this.dashboardMode) {
      this.itemsPerPage = 10;  // 5개에서 10개로 변경
    }
    // 쿼리 파라미터에서 filter 추출
    this.filterQuery = this.$route.query.filter || '';
    this.checkIfMobile();
    this.loadTags(); // 데이터 로드 메소드 호출
    this.loadDashboardSummary();
    // 대시보드 모드에서는 자동 갱신을 늦게 시작
    if (this.dashboardMode) {
      // 대시보드 모드에서는 30초 간격으로 갱신
      setTimeout(() => {
        this.updateInterval = 30;
        this.startUpdateTimer();
      }, 5000); // 5초 후에 자동 갱신 시작
    } else {
      this.startUpdateTimer();
    }
  },
  watch: {
    'selectedFilters.codeGroup'() {
      this.updateSearchText();
    },
    'selectedFilters.deviceGroup'() {
      this.updateSearchText();
    }
  },
  mounted() {
    window.addEventListener('resize', this.checkIfMobile);
  },
  beforeUnmount() {
    if (this.updateTimer) {
      clearInterval(this.updateTimer);
    }
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    isStale(tag) {
      try {
        if (!tag || !tag.tag_sensingtime) return false;
        const sensedAt = new Date(tag.tag_sensingtime);
        if (isNaN(sensedAt.getTime())) return false;
        const now = Date.now();
        const diffMs = now - sensedAt.getTime();
        return diffMs > 3600 * 1000; // 1 hour
      } catch (e) {
        return false;
      }
    },
    normalizeDeviceGroup(value) {
      // DB devicename 토큰으로 매핑
      const map = {
        'VarioS': 'Vario_Suction',
        'Pulse_Oxi': 'Pulse_Oxi',
        'H_Pulse_Oxi': 'H_Pulse_Oxi',
        'H_Pulse': 'H_Pulse',
        'Infusion': 'Infusion',
        'Feeding': 'Feeding',
        'Patient_M': 'Patient_M',
        'DVT': 'DVT',
        'SCD': 'SCD'
      };
      return map[value] || value;
    },
    updateSearchText() {
      const arr = [];
      if (this.selectedFilters.codeGroup) arr.push(this.selectedFilters.codeGroup);
      if (this.selectedFilters.deviceGroup) arr.push(this.selectedFilters.deviceGroup);
      this.filters.searchText = arr.join('');
      this.currentPage = 1;
      this.loadTags();
      this.loadDashboardSummary();
    },
    checkIfMobile() {
      this.isMobile = window.innerWidth <= 768;
      // 데스크톱으로 변경되면 테이블 뷰로 자동 전환
      if (!this.isMobile) {
        this.showCardView = false;
      }
    },
    toggleView() {
      this.showCardView = !this.showCardView;
    },
    loadTags() {
      const company = localStorage.getItem('company');
      const offset = (this.currentPage - 1) * this.itemsPerPage;
      
      const params = {
        company,
        limit: this.itemsPerPage,
        offset: offset,
        sortKey: this.sortKey,
        sortOrder: this.sortOrder,
        showExported: this.showExportedEquipment
      };

      // 버튼 기반 필터 처리
      const codeGroup = this.selectedFilters.codeGroup || '';
      const deviceToken = this.selectedFilters.deviceGroup 
        ? this.normalizeDeviceGroup(this.selectedFilters.deviceGroup)
        : '';

      if (codeGroup && deviceToken) {
        // 병동 + 디바이스 동시 선택: devicename 접두어로 정확 필터
        params.devicename = `${codeGroup}${deviceToken}`;
      } else if (codeGroup && !deviceToken) {
        // 병동만 선택: devicename 접두어 병동만
        params.devicename = `${codeGroup}`;
      } else if (!codeGroup && deviceToken) {
        // 디바이스만 선택: 부분 검색으로 searchText 사용
        if (deviceToken.length >= 2) {
          params.searchText = deviceToken;
        }
      } else {
        // 자유 검색어 사용 시: searchText 전달
        if (this.filters.searchText && this.filters.searchText.length >= 2) {
          params.searchText = this.filters.searchText;
          console.log('검색어:', this.filters.searchText); // 디버깅용
        }
      }
      // 라우트의 filter 쿼리가 있으면 devicename 프리픽스로 적용(우선순위 낮음)
      if (!params.devicename && !params.searchText && this.filterQuery) {
        params.devicename = this.filterQuery;
      }
      
      console.log('API 요청 파라미터:', params); // 디버깅용
      
      axios.get('/api/oldTagList', { params })
      .then(response => {
        console.log('Response:', response.data);
        this.tags = response.data.data || [];
        this.totalItems = response.data.total || 0;
        this.updateSearchInfo();
      })
      .catch(error => {
        console.error('Error fetching tag data:', error);
        this.tags = [];
        this.totalItems = 0;
      });
    },
    
    sortTags(key) {
      this.sortOrder = this.sortKey === key ? -this.sortOrder : 1;
      this.sortKey = key;
      this.currentPage = 1;
      this.loadTags(); // 서버에서 새로 데이터 로드
    },
    
    changeItemsPerPage() {
      this.currentPage = 1; // 페이지를 첫 번째로 리셋
      this.loadTags(); // 새로운 아이템 수로 데이터 로드
    },
    
    // 페이지네이션 메서드들
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.loadTags();
      }
    },
    
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.loadTags();
      }
    },
    
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages && page !== this.currentPage) {
        this.currentPage = page;
        this.loadTags();
      }
    },
    
    updateSearchInfo() {
      if (this.filters.searchText && this.filters.searchText.length >= 2) {
        this.searchInfo = `Found ${this.totalItems} result(s) for "${this.filters.searchText}"`;
      } else {
        this.searchInfo = '';
      }
    },
    
    handleSearchInput() {
      clearTimeout(this.searchTimeout);
      
      if (this.selectedFilters.searchText.length > 0 && this.selectedFilters.searchText.length < 2) {
        this.searchInfo = '최소 2자 이상 입력하세요';
        return;
      }
      
      this.searchInfo = '';
      
      if (this.selectedFilters.searchText.length >= 2) {
        this.searchTimeout = setTimeout(() => {
          this.filters.searchText = this.selectedFilters.searchText;
          this.currentPage = 1;
          this.loadTags();
        }, 500);
      } else if (this.selectedFilters.searchText.length === 0) {
        this.filters.searchText = '';
        this.currentPage = 1;
        this.loadTags();
      }
    },
    
    startUpdateTimer() {
      if (this.updateTimer) {
        clearInterval(this.updateTimer);
      }
      this.updateTimer = setInterval(() => {
        this.loadTags();
        this.loadDashboardSummary();
      }, this.updateInterval * 1000);
    },
    async loadDashboardSummary() {
      try {
        const company = localStorage.getItem('company') || 'SDAA';
        const wardPrefix = this.selectedFilters.codeGroup || '';
        let res;
        if (wardPrefix) {
          res = await axios.get('/api/dashboardPrefix', { params: { company, prefix: wardPrefix } });
        } else {
          res = await axios.get('/api/dashboard', { params: { company } });
        }
        // 응답 매핑
        this.dashboard.totalAssets = res.data.totalAssets ?? 0;
        this.dashboard.lowBatteryAssets = res.data.lowBatteryAssets ?? 0;
        this.dashboard.inactiveAssets = res.data.inactiveAssets ?? 0;
      } catch (e) {
        console.error('대시보드 요약 로드 실패:', e);
      }
    },
    formatSensingTime(sensingTime) {
      if (!sensingTime) return 'N/A';
      const date = new Date(sensingTime);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      const hours = date.getHours();
      const minutes = date.getMinutes().toString().padStart(2, '0');
      const years = date.getFullYear();
      return `${years}/${month}/${day} ${hours}:${minutes}`;
    },
    getBatteryStatus(voltage) {
      if (voltage >= 2.7) {
        return 'battery_good';
      } else if (voltage >= 2.3 && voltage < 2.7) {
        return 'battery_mid';
      } else {
        return 'battery_none';
      }
    },
    getArrowClass(key) {
      if (this.sortKey === key) {
        return this.sortOrder === 1 ? 'arrow-up' : 'arrow-down';
      }
      return 'arrow-default';
    },
    openEditSidebar(tag) {
      this.selectedTag = tag;
      this.isEditSidebarVisible = true;
    },
    async updateTag(updatedTag) {
      try {
        console.log('=== TAG UPDATE DEBUG START ===');
        console.log('Original updatedTag:', updatedTag);
        
        // company 정보 추가 확인
        const company = localStorage.getItem('company');
        console.log('Company from localStorage:', company);
        
        // FormData 객체 생성 (AssetPage.vue와 동일한 방식)
        const formData = new FormData();
        
        // 필드들을 FormData에 추가
        formData.append('tag_mac', updatedTag.tag_mac);
        formData.append('devicename', updatedTag.devicename || '');
        formData.append('taglocation', updatedTag.taglocation || '');
        formData.append('building', updatedTag.building || '');
        formData.append('floor', updatedTag.floor || '');
        formData.append('assignedzone', updatedTag.assignedzone || '');
        formData.append('devicetype', updatedTag.devicetype || '');
        formData.append('company', company);
        
        // 디버깅을 위한 FormData 내용 출력
        console.log('Sending FormData:');
        for (let [key, value] of formData.entries()) {
          console.log(`${key}: ${value}`);
        }
        
        console.log('Calling API: /api/updateAssetDetails');
        
        // AssetPage.vue와 동일한 API 엔드포인트 사용
        const response = await axios.post('/api/updateAssetDetails', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        
        console.log('Raw response:', response);
        console.log('Response status:', response.status);
        console.log('Response data:', response.data);
        
        if (response.status === 200 || response.status === 204) {
          console.log('태그 업데이트 성공:', response.data);
          
          // 로컬 데이터 업데이트
          const index = this.tags.findIndex(tag => tag.tag_mac === updatedTag.tag_mac);
          if (index !== -1) {
            this.tags[index] = { ...this.tags[index], ...updatedTag };
          }
          
          // 목록 새로고침
          await this.loadTags();
          
          // 편집 모드 종료
          this.selectedTag = null;
          this.isEditSidebarVisible = false;
          
          alert('태그가 성공적으로 업데이트되었습니다.');
        } else {
          console.error('Unexpected response status:', response.status);
          alert('태그 업데이트에 실패했습니다.');
        }
        
        console.log('=== TAG UPDATE DEBUG END ===');
        
      } catch (error) {
        console.error('=== TAG UPDATE ERROR ===');
        console.error('Error object:', error);
        console.error('Error message:', error.message);
        
        if (error.response) {
          console.error('Error response status:', error.response.status);
          console.error('Error response data:', error.response.data);
          console.error('Error response headers:', error.response.headers);
        }
        
        alert('태그 업데이트 중 오류가 발생했습니다: ' + error.message);
      }
    },
    closeEditSidebar() {
      this.selectedTag = null;
      this.isEditSidebarVisible = false;
    },
    applyFilter(filterValue) {
      console.log('applyFilter 호출됨:', filterValue);
      this.filters.searchText = filterValue;
      this.selectedFilters.searchText = filterValue;
      this.currentPage = 1;
      console.log('searchText 설정됨:', this.filters.searchText);
      this.loadTags();
    },
    clearFilter() {
      console.log('clearFilter 호출됨');
      this.selectedFilters.codeGroup = '';
      this.selectedFilters.deviceGroup = '';
      this.filters.searchText = '';
      this.selectedFilters.searchText = '';
      this.currentPage = 1;
      console.log('searchText 초기화됨:', this.filters.searchText);
      this.loadTags();
    },
    toggleCodeGroup(value) {
      if (this.selectedFilters.codeGroup === value) {
        this.selectedFilters.codeGroup = '';
      } else {
        this.selectedFilters.codeGroup = value;
      }
      this.updateSearchText();
    },
    toggleDeviceGroup(value) {
      if (this.selectedFilters.deviceGroup === value) {
        this.selectedFilters.deviceGroup = '';
      } else {
        this.selectedFilters.deviceGroup = value;
      }
      this.updateSearchText();
    },
    clearCodeGroup() {
      this.selectedFilters.codeGroup = '';
    },
    clearDeviceGroup() {
      this.selectedFilters.deviceGroup = '';
    },
    async checkUserPermission() {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          this.isAdmin = false;
          return;
        }

        const response = await axios.get('/api/checkadmin', {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        this.isAdmin = response.data.isadmin === 1;
      } catch (error) {
        console.error('사용자 권한 확인 오류:', error);
        this.isAdmin = false;
      }
    },
    openExportModal(tag) {
      this.selectedTagForExport = tag;
      this.isExportModalVisible = true;
    },
    closeExportModal() {
      this.isExportModalVisible = false;
      this.selectedTagForExport = null;
    },
    async handleEquipmentExported(exportData) {
      console.log('장비 반출 완료:', exportData);
      // 목록 새로고침
      await this.loadTags();
      await this.loadDashboardSummary();
    },
    toggleExportedEquipment() {
      this.showExportedEquipment = !this.showExportedEquipment;
      this.currentPage = 1;
      this.loadTags();
    },
    async cancelExport(tag) {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          alert('로그인이 필요합니다.');
          return;
        }

        const response = await axios.post('/api/equipment/export/cancel', {
          tag_mac: tag.tag_mac
        }, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        });

        if (response.data.success) {
          alert('장비 반출이 취소되었습니다.');
          // 목록 새로고침
          await this.loadTags();
          await this.loadDashboardSummary();
        } else {
          alert('반출 취소에 실패했습니다: ' + response.data.message);
        }
      } catch (error) {
        console.error('반출 취소 오류:', error);
        alert('반출 취소 중 오류가 발생했습니다.');
      }
    }
  },
  computed: {
    totalPages() {
      return Math.ceil(this.totalItems / this.itemsPerPage);
    },
    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);
      
      // 끝에서 시작점 조정
      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
};
</script>

<style scoped>
.taglist-container {
  padding: 10px;
  max-width: 1680px;
  margin: 0 auto;
  background-color: #f5f5f5;
}

/* 필터 섹션 (상단) */
.filter-section {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  padding: 20px 0;
  background: #f8f9fa;
  border-radius: 8px;
  margin: 20px;
}

.filter-wrapper {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  align-items: flex-start;
}

.dashboard-summary {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.summary-item {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 10px 14px;
  min-width: 120px;
  box-shadow: 0 1px 2px rgba(0,0,0,0.04);
}

.summary-item .summary-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 4px;
}

.summary-item .summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
}

.summary-item.warning .summary-value { color: #d97706; }
.summary-item.inactive .summary-value { color: #b91c1c; }

.filter-buttons {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 16px;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-end;
  max-width: 100%;
  width: 100%;
}
  
.filter-row {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  width: 100%;
}

.search-input {
  width: 400px;
  padding: 12px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  font-size: 14px;
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.search-input:focus {
  outline: none;
  border-color: #4e73df;
  box-shadow: 0 4px 12px rgba(78, 115, 223, 0.15);
}

.items-per-page-selector {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.items-per-page-selector label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.items-select {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  background: white;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 80px;
}

.items-select:focus {
  outline: none;
  border-color: #4e73df;
  box-shadow: 0 2px 8px rgba(78, 115, 223, 0.15);
}

.search-info {
  font-size: 12px;
  color: #666;
  text-align: center;
  font-style: italic;
  width: 100%;
  margin-top: 8px;
}

/* 메인 콘텐츠 카드 */
.content-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.card-header {
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
  background: #f8f9fa;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.card-header h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.header-controls {
  display: flex;
  align-items: center;
  gap: 10px;
}

.header-search {
  display: flex;
  align-items: center;
  gap: 15px;
}

.view-toggle-btn {
  background: #4e73df;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.view-toggle-btn:hover {
  background: #3a5bc7;
}

.view-toggle-btn.active {
  background: #1cc88a;
}

.results-info {
  font-size: 14px;
  color: #666;
  font-weight: 500;
}

/* 테이블 컨테이너 */
.table-container {
  overflow-x: auto;
  max-height: 70vh;
  overflow-y: auto;
}

.tags-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
}

.tags-table thead {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.tags-table thead th {
  background-color: #f8f9fa;
  padding: 16px 12px;
  text-align: left;
  cursor: pointer;
  position: relative;
  font-weight: 600;
  color: #333;
  border-bottom: 2px solid #e0e0e0;
  white-space: nowrap;
  user-select: none;
  transition: background-color 0.2s;
}

.tags-table thead th:hover {
  background-color: #e9ecef;
}

.tags-table tbody td {
  padding: 12px;
  border-bottom: 1px solid #f0f0f0;
  vertical-align: middle;
  color: #333;
}

.tags-table tbody tr:hover {
  background-color: #f8f9fa;
}

/* 최근 1시간 초과 데이터 하이라이트 */
.stale-row {
  background-color: #fff7e6; /* 연한 주황톤 */
}
.stale-row:hover {
  background-color: #ffefd6;
}

/* 정렬 화살표 */
.arrow-default::after {
  content: '↕';
  color: #ccc;
  margin-left: 5px;
}

.arrow-up::after {
  content: '↑';
  color: #4e73df;
  margin-left: 5px;
}

.arrow-down::after {
  content: '↓';
  color: #4e73df;
  margin-left: 5px;
}

/* 아이콘 및 상태 스타일 */
.rssi-good {
  color: #1cc88a;
}

.rssi-mid {
  color: #f6c23e;
}

.rssi-low {
  color: #e74a3b;
}

.thermostat {
  color: #e74a3b;
}

.battery_good {
  color: #1cc88a;
}

.battery_mid {
  color: #f6c23e;
}

.battery_none {
  color: #36b9cc;
}

/* 페이지네이션 */
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  gap: 8px;
  flex-wrap: wrap;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
}

/* Edit 버튼 스타일 */
.edit-btn {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  background-color: #4e73df;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.edit-btn:hover {
  background-color: #3a5bc7;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(78, 115, 223, 0.3);
}

.pagination-btn {
  padding: 8px 16px;
  border: 1px solid #e0e0e0;
  background-color: white;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  font-size: 14px;
  font-weight: 500;
}

.pagination-btn:hover:not(:disabled) {
  background-color: #4e73df;
  color: white;
  border-color: #4e73df;
}

.pagination-btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
  background-color: #f8f9fa;
}

.page-numbers {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.page-number {
  padding: 8px 12px;
  border: 1px solid #e0e0e0;
  background-color: white;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s;
  font-size: 14px;
  min-width: 40px;
  text-align: center;
}

.page-number:hover {
  background-color: #4e73df;
  color: white;
  border-color: #4e73df;
}

.page-number.active {
  background-color: #4e73df;
  color: white;
  border-color: #4e73df;
  font-weight: 600;
}

/* 반응형 디자인 */
@media screen and (max-width: 1200px) {
  .taglist-container {
    padding: 8px;
    max-width: 100%;
  }
  
  .search-input {
    width: 350px;
  }
  
  .card-header {
    padding: 16px 20px;
  }
  
  .card-header h2 {
    font-size: 22px;
  }
  
  .results-info {
    font-size: 13px;
  }
  
  .tags-table {
    font-size: 13px;
  }
  
  .tags-table thead th {
    padding: 12px 8px;
  }
  
  .tags-table tbody td {
    padding: 10px 8px;
  }
}

/* 필터 버튼 스타일 */
  
.filter-btn {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  background-color: #f8f9fa;
  color: #333;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: all 0.2s;
  min-width: 80px;
  text-align: center;
  margin: 2px;
}

.filter-btn:hover {
  background-color: #e9ecef;
}

.filter-btn.active {
  background-color: #4e73df;
  color: white;
  border-color: #4e73df;
}

.clear-btn {
  background-color: #dc3545;
  color: white;
}

.clear-btn:hover {
  background-color: #c82333;
}

/* 반출 버튼 스타일 */
.export-btn {
  padding: 6px 12px;
  border: 1px solid #e0e0e0;
  background-color: #28a745;
  color: white;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.export-btn:hover:not(:disabled) {
  background-color: #218838;
  transform: translateY(-1px);
  box-shadow: 0 2px 6px rgba(40, 167, 69, 0.3);
}

.export-btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

.card-export-btn {
  width: 100%;
  padding: 8px 12px;
  font-size: 13px;
}

/* 반출 취소 버튼 스타일 */
.export-cancelled-btn {
  background-color: #dc3545 !important; /* 빨간색 배경 */
  border-color: #dc3545 !important;
}

.export-cancelled-btn:hover {
  background-color: #c82333 !important; /* 호버 시 더 진한 빨간색 */
  border-color: #c82333 !important;
}

/* 반출된 장비 토글 버튼 */
.exported-toggle {
  margin-left: 10px;
}

.exported-toggle-btn {
  background: #17a2b8;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s;
}

.exported-toggle-btn:hover {
  background: #138496;
}

.exported-toggle-btn.active {
  background: #dc3545;
}

.exported-toggle-btn.active:hover {
  background: #c82333;
}

/* 반출된 장비 행 스타일 */
.exported-row {
  background-color: #d4edda !important; /* 연한 초록색 배경 */
  border-left: 4px solid #28a745; /* 왼쪽에 초록색 테두리 */
}

.exported-row:hover {
  background-color: #c3e6cb !important; /* 호버 시 더 진한 초록색 */
}

/* 반출된 장비 카드 스타일 */
.exported-card {
  background-color: #d4edda !important; /* 연한 초록색 배경 */
  border: 2px solid #28a745; /* 초록색 테두리 */
  box-shadow: 0 2px 8px rgba(40, 167, 69, 0.2); /* 초록색 그림자 */
}

.exported-card:hover {
  background-color: #c3e6cb !important; /* 호버 시 더 진한 초록색 */
  box-shadow: 0 4px 12px rgba(40, 167, 69, 0.3); /* 호버 시 더 진한 그림자 */
}
</style> 